import React, { createContext, useContext, useState } from 'react';
import alliumTheme from '@telus-uds/theme-allium';
import koodoTheme from '@telus-uds/theme-koodo';
import publicMobileTheme from '@telus-uds/theme-public-mobile';
import { useTranslation } from 'react-i18next';

const themes = {
  TELUS: alliumTheme,
  Koodo: koodoTheme,
  PUBLIC_MOBILE: publicMobileTheme,
};

const BrandThemeContext = createContext();

export const useTheme = () => useContext(BrandThemeContext);

export const ThemeProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentTheme, setCurrentTheme] = useState(alliumTheme);
  const [language, setLanguage] = useState('en');
  const [currentBrand, setCurrentBrand] = useState('TELUS');
  const [testMode, setTestMode] = useState(false);

  const switchThemeAndLanguage = (brand, language) => {
    console.log('Switching theme and language:', brand, language);
    setCurrentTheme(themes[brand] || alliumTheme); // Fallback to TELUS theme if brand is not recognized
    setCurrentBrand(brand);
    setLanguage(language);
    i18n.changeLanguage(language);
  };

  const switchTestMode = (isTestMode) => {
    console.log('Switching test mode:', isTestMode);
    setTestMode(isTestMode || false);
  };

  return (
    <BrandThemeContext.Provider
      value={{ currentTheme, currentBrand, switchThemeAndLanguage, testMode, switchTestMode }}
    >
      {children}
    </BrandThemeContext.Provider>
  );
};
